import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomPermissionAuthService } from '../services/custom-permission-auth.service';

@Directive({
  selector: '[appHasCustomPermission]'
})
export class HasCustomPermissionDirective implements OnDestroy {
  private permissionSubscription?: Subscription;
  private currentCustomPermissions: string[] = [];

  @Input() set appHasCustomPermission(permission: string | string[]) {
    this.currentCustomPermissions = Array.isArray(permission) ? permission : [permission];
    this.updateView();
  }

  @Input() appHasCustomPermissionMode: 'all' | 'any' = 'any';

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: CustomPermissionAuthService
  ) { 

    this.permissionSubscription = this.permissionService.permissionsChanged$.subscribe(() => {
      this.updateView();
    });
  }

  private updateView(): void {
    if (this.currentCustomPermissions.length === 0) {
      this.viewContainer.clear();
      return;
    }

    let hasPermission: boolean;

    if (this.appHasCustomPermissionMode === 'all') {
      hasPermission = this.permissionService.hasAllPermissions(this.currentCustomPermissions);
    } else {
      hasPermission = this.permissionService.hasAnyPermission(this.currentCustomPermissions);
    }

    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  ngOnDestroy(): void {
    if (this.permissionSubscription) {
      this.permissionSubscription.unsubscribe();
    }
  }

}
